import Vue from "vue";
import TimeSlotsView from "../appointments/components/TimeSlotsView.vue";
import $ from "jquery";
import moment from "moment";
import _ from "underscore";

document.addEventListener("DOMContentLoaded", (_) => {
  const bus = new Vue();

  var props = {
    bus: bus,
    onChoose: function (slots) {
      var form = $("form#choose-provider");
      $("#appointment_type", form).val($("#time_slot_form_appointment_type").val());
      $("#slots", form).val(JSON.stringify(slots));
      form[0].submit();
    },

    loadData: function (viewComponent) {
      var selectedAppointmentType = $("#time_slot_form_appointment_type");

      var appointment_type = selectedAppointmentType.length > 0 ? selectedAppointmentType.val() : $(".js-appointment-type-hidden").val();
      var data = {
        provider_filter: {
          appointment_type,
        },
      };

      var location = $(".js-location").val();
      if (location !== "") data.provider_filter.location_id = location;

      var staff_profile_id = $(".js-staff-profile-id").val();
      if (staff_profile_id && staff_profile_id !== "") data.provider_filter.staff_profile_id = staff_profile_id;
      $("#specialities-filter").toggle(staff_profile_id === "");

      var gender = $(".js-gender:checked").val();
      if (gender !== "") data.provider_filter.gender = gender;

      var speciality = $(".js-speciality").val();
      if (speciality !== "") data.provider_filter.speciality = speciality;

      var service = $(".js-services").val();
      if (service && service !== "") data.provider_filter.service = service;

      if ($(".js-accepts-new-patients").is(":checked")) data.provider_filter.accepts_new_patients = true;

      return data;
    },
  };

  // Function to initialize locations independently of practitioners
  const initializeLocations = async (viewComponent) => {
    if ($(".js-location").length > 0) {
      try {
        // Get locations that have practitioners assigned to them
        const data = await $.getJSON("/appointments/staff_profile_data", {});
        var locations = data.locations || [];
        var $locations = $(".js-location");
        var location_id = $locations.val();

        if (locations.length > 0) {
          locations.unshift(["Any", ""]);
          updateFilterOptions($locations, locations, location_id);
        }
      } catch (error) {
        console.error("Error initializing locations:", error);
      }
    }
  };

  // Form fields
  bus.$on("mounted", (viewComponent) => {
    // Initialize locations regardless of practitioner filter
    initializeLocations(viewComponent);

    // Only call getProviderIds if practitioner filter exists
    if ($(".js-staff-profile-id").length > 0) {
      getProviderIds(viewComponent);
      $(".js-staff-profile-id")
        .chosen()
        .change((_) => getProviderIds(viewComponent));
    }

    // Ensure the "All" option is selected for services on initial load
    if ($(".js-services").length > 0 && !$(".js-services").val()) {
      $(".js-services").val("").trigger("chosen:updated");
    }

    $(".js-speciality")
      .chosen()
      .change(() => getFilteredData(viewComponent));
    $(".js-location")
      .chosen()
      .change(() => getFilteredData(viewComponent));
    $(".js-services")
      .chosen()
      .change(() => getFilteredData(viewComponent));
    $(".js-gender").on("change", () => getFilteredData(viewComponent));
    $("#time_slot_form_appointment_type").on("change", () => getFilteredData(viewComponent));
    $(".js-accepts-new-patients").on("change", () => getFilteredData(viewComponent));

    // Force reload time slots with default values on initial page load
    setTimeout(() => viewComponent.reload(), 100);
  });

  const getFilteredData = (viewComponent) => {
    const type = $("#time_slot_form_appointment_type").val() || null;
    const value = $(".js-accepts-new-patients:checked").val();
    const service = $(".js-services").val() || null;
    const speciality = $(".js-speciality").val() || null;
    const gender = $(".js-gender:checked").val() || null;
    const location = $(".js-location").val() || null;

    var params = {};
    if (value !== null) {
      params["accept_new_patients"] = value;
    }
    if (type) {
      params["appointment_types"] = type;
    }
    if (service) {
      params["services"] = service;
    }
    if (speciality) {
      params["speciality"] = speciality;
    }
    if (gender) {
      params["gender"] = gender;
    }
    if (location) {
      params["location_id"] = location;
    }

    // Make the AJAX call to get filtered staff profiles
    $.getJSON("/appointments/staff_profiles", params, (data) => {
      const items = data.items;
      updateProvidersList(viewComponent, items);
    });

    // Trigger a reload of time slots even when no specific params are set
    viewComponent.reload();
  };

  const getProviderIds = (viewComponent) => {
    const optionValues = $(".js-staff-profile-id option")
      .map(function () {
        const value = $(this).val() || null;
        const onDutyStaffId = $(this).data("on-duty-staff-id");
        return value === "on_duty_doctor" ? onDutyStaffId : value;
      })
      .get();

    let selectedProfileId = $(".js-staff-profile-id").val();

    if (selectedProfileId === "on_duty_doctor") {
      const selectedElement = $(".js-staff-profile-id");
      const onDutyDoctorOptions = selectedElement.find('option[value="on_duty_doctor"]');
      const onDutyDoctorCount = onDutyDoctorOptions.length;

      if (onDutyDoctorCount <= 1) {
        selectedProfileId = onDutyDoctorOptions.data("on-duty-staff-id");
      } else {
        selectedProfileId = onDutyDoctorOptions
          .map(function () {
            return $(this).data("on-duty-staff-id");
          })
          .get();
      }
    }

    const staff_profile_ids = selectedProfileId ? selectedProfileId : optionValues;
    loadStaffData(viewComponent, staff_profile_ids);
  };

  const updateProvidersList = (viewComponent, items) => {
    const staffProfileIdSelector = $(".js-staff-profile-id");
    const selectedProfileId = staffProfileIdSelector.val();
    let onDutyDoctorOptionVisible = false;

    staffProfileIdSelector.empty();

    items.forEach((staffProfile) => {
      var dataSet = staffProfile[2] ? staffProfile[2].data : null;
      const option = $(`<option value=${staffProfile[1]}>${staffProfile[0]}</option>`);

      if (staffProfile[1] === "on_duty_doctor") {
        option.data("on-duty-staff-id", dataSet["on-duty-staff-id"]);

        if (staffProfile[1] === "on_duty_doctor" && onDutyDoctorOptionVisible) {
          option.attr("style", "display: none;");
        } else {
          onDutyDoctorOptionVisible = true;
        }
      }
      staffProfileIdSelector.append(option);

      if (parseInt(selectedProfileId) === staffProfile[1] || selectedProfileId === "on_duty_doctor") {
        option.prop("selected", true);
      }
    });

    staffProfileIdSelector.trigger("chosen:updated");
    getProviderIds(viewComponent);
  };

  const updateFilterOptions = ($selectElement, options, selectedValue) => {
    $selectElement.empty();

    options.forEach(function (option) {
      let opt;

      if (Array.isArray(option)) {
        opt = $("<option></option>").attr("value", option[1]).text(option[0]);
      } else {
        if (option === "Please select") {
          opt = $("<option></option>").attr("value", "").text(option).prop("disabled", true).prop("selected", true);
        } else if (option === "All" || option === "Any") {
          opt = $("<option></option>").attr("value", "").text(option);
          if (!selectedValue) {
            opt.prop("selected", true);
          }
        } else {
          opt = $("<option></option>").attr("value", option).text(option);
        }
      }

      if (option === selectedValue || String(option[1]) === selectedValue) {
        opt.prop("selected", true);
      }

      $selectElement.append(opt);
    });
    $selectElement.trigger("chosen:updated");
  };

  new Vue({
    el: "#available-time-slots",
    render: (h) => h(TimeSlotsView, { props }),
  });

  // Advanced filters
  $("#show-advanced-filters").on("click", function (e) {
    e.preventDefault();
    $("#advanced-filters").show();
    $("#show-advanced-filters").hide();
    $("#hide-advanced-filters").show();
    setTimeout(function () {
      $(".chosen-select").chosen({ width: "100%" });
    }, 100);
  });
  $("#hide-advanced-filters").on("click", function (e) {
    e.preventDefault();
    $("#advanced-filters").hide();
    $("#show-advanced-filters").show();
    $("#hide-advanced-filters").hide();
  });

  //Clear button to reset all filter selections
  $("#reset-filters").on("click", function (e) {
    e.preventDefault();
    $("#time_slot_form_appointment_type").val("").trigger("chosen:updated");
    $(".js-staff-profile-id").val("").trigger("chosen:updated");
    $(".js-speciality").val("").trigger("chosen:updated");
    $(".js-location").val("").trigger("chosen:updated");
    $(".js-services").val("").trigger("chosen:updated");
    $(".js-gender").prop("checked", false);
    $(".js-accepts-new-patients").prop("checked", false);

    $(".js-location").trigger("change");
  });

  // Calendar
  async function loadStaffData(viewComponent, staff_profile_ids) {
    const data = await $.getJSON("/appointments/staff_profile_data", { staff_profile_ids: staff_profile_ids });
    var locations = data.locations || [];
    var services = data.services || [];
    var specialities = data.specialities || [];
    var accepts_new_patients = data.accepts_new_patients;

    var $locations = $(".js-location");
    var $services = $(".js-services");
    var $specialities = $(".js-speciality");
    var service_name = $services.val();
    var location_id = $locations.val();
    var speciality = $specialities.val();

    locations.unshift(["Any", ""]);
    services.unshift($services.first().data("placeholder")); // This value is different depending on the pricing mode that we use
    specialities.unshift("All");

    // Don't update services if service is already selected and we're not in initial load
    if (!(service_name && services.length <= 1)) {
      updateFilterOptions($services, services, service_name);
    }
    updateFilterOptions($locations, locations, location_id);
    updateFilterOptions($specialities, specialities, speciality);

    if (!accepts_new_patients) {
      $(".js-accepts-new-patients").prop("disabled", true);
      $("#accept-new-patients-label").addClass("input-muted");
    } else {
      $(".js-accepts-new-patients").prop("disabled", false);
      $("#accept-new-patients-label").removeClass("input-muted");
    }

    viewComponent.reload();
  }

  // If we set .d-none class to advanced filter block in HTML, the widths of select-chosen will be
  // ruined. See this bug -- https://github.com/harvesthq/chosen/issues/92
  $("#advanced-filters").hide();
  $(".d-none").hide().removeClass("d-none");

  $("#dob").datetimepicker({
    useCurrent: false,
    format: "L",
    maxDate: moment().subtract(1, "days").toDate(),
  });

  $("#time_slot_form_appointment_type").on("change", function () {
    var selectedOptionClass = $(this).find("option:selected").attr("class").replace("option-", "selected-");
    var chosenSelect = $(this).next(".chosen-container");

    // Remove previous class if any
    chosenSelect.removeClass(function (index, className) {
      return (className.match(/(^|\s)option-\S+/g) || []).join(" ");
    });

    // Add new class
    if (selectedOptionClass) {
      chosenSelect.addClass(selectedOptionClass);
    }
  });
});
